export const MIN_METERS_DISTANCE = 100;
export const MIN_FEET_DISTANCE = 330;

export const MAX_METERS_DISTANCE = 1000;
export const MAX_FEET_DISTANCE = 3300;
